import { ReactNode } from 'react'

interface ProtectedRouteProps {
  children: ReactNode
}

/**
 * Simplified ProtectedRoute component that always shows content
 * (page visibility system has been removed for MVP simplification)
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  return <>{children}</>
}

export default ProtectedRoute